import { createTheme } from "@mui/material";

export const DarkTheme = createTheme({
  typography: {
    fontFamily: "Lexend",
  },

  palette: {
    primary: {
      main: "#F1F5F7",
      dark: "#22272E",
      light: "",
      contrastText: "#0E080C",
    },

    secondary: {
      main: "#0E080C",
      dark: "",
      light: "",
    },

    text: {
      primary: "#F1F5F7",
      secondary: "#000748",
    },

    background: {
      default: "#080809",
      paper: "#100F14",
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "::-webkit-scrollbar": {
          width: "0px",
        },
        body: {
          transition: "0.3s",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          textTransform: "capitalize",
        },
      },
    },
  },
});

export const LightTheme = createTheme({
  typography: {
    fontFamily: "Lexend",
  },

  palette: {
    primary: {
      main: "#0E080C",
      dark: "#22272E",
      light: "",
      contrastText: "#F1F5F7",
    },

    secondary: {
      main: "#F1F5F7",
      dark: "",
      light: "",
    },

    text: {
      primary: "#000748",
      secondary: "#F1F5F7",
    },

    background: {
      default: "#F0F2F6",
      paper: "#F8F8F9",
    },
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "::-webkit-scrollbar": {
          width: "0px",
        },
        body: {
          transition: "0.3s",
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        listbox: {
          textTransform: "capitalize",
        },
      },
    },
  },
});
